import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/inventory/items-reservation/";

export function getItemRequestProcessDetail(itemRequestID) {
  return http.get(apiEndpoint + "item-request-process-detail/" + itemRequestID);
}

export function getItemsRequest(
  operationCardID = 0,
  salesOrderItemID = 0,
  warehouseID = 0,
  outletID = 0,
  productionOrderID = 0
) {
  return http.get(
    apiEndpoint +
      "items-request/" +
      operationCardID +
      "/" +
      salesOrderItemID +
      "/" +
      warehouseID +
      "/" +
      outletID +
      "/" +
      productionOrderID
  );
}

export function getItemsRequestBySoItem(salesOrderItemID = 0) {
  return http.get(apiEndpoint + "items-request-so-item/" + salesOrderItemID);
}

export function getItemsReservation(
  deliveryOrderID = 0,
  operationCardID = 0,
  journeyID = 0,
  warehouseID = 0,
  outletID = 0,
  orderType = "-",
  productionOrderID = 0
) {
  return http.get(
    apiEndpoint +
      "items-reservation/" +
      deliveryOrderID +
      "/" +
      operationCardID +
      "/" +
      journeyID +
      "/" +
      warehouseID +
      "/" +
      outletID +
      "/" +
      orderType +
      "/" +
      productionOrderID
  );
}

export function saveItemsRequest(itemsRequest) {
  return http.post(apiEndpoint + "items-request", itemsRequest);
}

export function saveProcessedItemsRequest(processedItemsRequest) {
  return http.post(
    apiEndpoint + "save-processed-items-request",
    processedItemsRequest
  );
}

export function saveDirectPickReservation(reservations) {
  return http.post(apiEndpoint + "direct-pick-reservation", reservations);
}

export function saveReservationItemsPickup(itemsPickup) {
  return http.post(apiEndpoint + "save-reservation-items-pickup", itemsPickup);
}

export function cancelItemReservation(reservationID) {
  return http.delete(apiEndpoint + "cancel-reservation/" + reservationID);
}

export function cancelItemRequest(requestID) {
  return http.delete(apiEndpoint + "cancel-request/" + requestID);
}

export function rejectItemRequest(requestID) {
  return http.delete(apiEndpoint + "reject-request/" + requestID);
}

export function saveReservations(reservations) {
  return http.post(apiEndpoint, reservations);
}

export function getOperationItemsReserved(operationCardID) {
  return http.get(apiEndpoint + "op-items-reserved/" + operationCardID);
}
